import { createContext, useContext, useState } from "react";

const ClipboardContext = createContext();

export const ClipboardProvider = ({ children }) => {
  const [clipboardItem, setClipboardItem] = useState(null);

  const startCopy = (item) => {
    setClipboardItem({ ...item, operation: "copy" });
  };

  const startMove = (item) => {
    setClipboardItem({ ...item, operation: "move" });
  };

  const clearClipboard = () => {
    setClipboardItem(null);
  };

  return (
    <ClipboardContext.Provider
      value={{ clipboardItem, startCopy, startMove, clearClipboard, setClipboardItem  }}
    >
      {children}
    </ClipboardContext.Provider>
  );
};

export const useClipboard = () => {
  const context = useContext(ClipboardContext);
  if (!context) {
    throw new Error("useClipboard must be used within a ClipboardProvider");
  }
  return context;
};

